<template>
    <HeaderSection />

    <section id="formulario">

        <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700 mx-5"
            @invalid-submit="onInvalidSubmit">

            <div
                class="container mx-auto max-w-7xl my-7 p-5 lg:p-8 lg:pr-10 bg-white bg-opacity-90 rounded-lg shadow-xl">

                <h1 class="font-bold text-center text-2xl">{{ $t('titulo.acreditacion.colegios') }}</h1>
                <h1 class="font-bold text-center text-xl">{{ $t('label.complete.el.form') }}</h1>

                <!-- Coordinator Data -->
                <h2 class="font-bold text-lg mt-5">{{ $t('label.datos.coordinador') }}</h2>
                <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-2">
                    <div class="w-full px-2 md:w-4/12">
                        <label class="block mb-1">{{ $t('label.documento') }}</label>
                        <Field name="dni" v-slot="{ field, errors }" v-model="formData.dni">
                            <InputText v-bind="field" type="text" class="input-base"
                                :placeholder="$t('label.documento')"
                                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                            <span class="text-sm text-red-500 p-error">
                                <ErrorMessage name="dni" />
                            </span>
                        </Field>
                    </div>
                    <div class="w-full px-2 md:w-4/12">
                        <label class="block mb-1">{{ $t('label.nombre') }}</label>
                        <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
                            <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.nombre')"
                                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                            <span class="text-sm text-red-500 p-error">
                                <ErrorMessage name="nombre" />
                            </span>
                        </Field>
                    </div>
                    <div class="w-full px-2 md:w-4/12">
                        <label class="block mb-1">{{ $t('label.apellido') }}</label>
                        <Field name="apellido" v-slot="{ field, errors }" v-model="formData.apellido">
                            <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.apellido')"
                                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                            <span class="text-sm text-red-500 p-error">
                                <ErrorMessage name="apellido" />
                            </span>
                        </Field>
                    </div>
                  </div>

                  <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-2">                  
                    <div class="w-full px-2 md:w-6/12">
                        <label class="block mb-1">{{ $t('label.empresa') }} {{ $t('label.institucion') }}</label>
                        <Field name="empresa" v-slot="{ field, errors }" v-model="formData.empresa">
                            <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.empresa')"
                                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                            <span class="text-sm text-red-500 p-error">
                                <ErrorMessage name="empresa" />
                            </span>
                        </Field>
                    </div>
                    <div class="w-full px-2 md:w-6/12">
                        <label class="block mb-1">{{ $t('label.mail') }}</label>
                        <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
                            <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.mail')"
                                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                            <span class="text-sm text-red-500 p-error">
                                <ErrorMessage name="mail" />
                            </span>
                        </Field>
                    </div>                </div>

                <!-- Students Data -->
                <h2 class="font-bold text-lg mt-8">{{ $t('label.alumnos') }}</h2>

                <div v-for="(alumno, index) in formData.alumnos" :key="index"
                    class="p-4 border rounded-lg mt-3 bg-gray-50 relative">
                    <button type="button" @click="removeAlumno(index)"
                        class="absolute top-2 right-2 text-red-600 hover:text-red-800 font-bold">
                        <i class="pi pi-times"></i>
                    </button>

                    <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
                        <div class="w-full px-2 md:w-4/12">
                            <label class="block mb-1">{{ $t('label.documento') }}</label>
                            <Field :name="`alumnos[${index}].dni`" v-slot="{ field, errors }" v-model="alumno.dni">
                                <InputText v-bind="field" type="text" class="input-base"
                                    :placeholder="$t('label.documento')"
                                    :class="{ 'bg-white': true, 'input-error': errors.length > 0 }" />
                                <span class="text-sm text-red-500 p-error">
                                    <ErrorMessage :name="`alumnos[${index}].dni`" />
                                </span>
                            </Field>
                        </div>
                        <div class="w-full px-2 md:w-4/12">
                            <label class="block mb-1">{{ $t('label.nombre') }}</label>
                            <Field :name="`alumnos[${index}].nombre`" v-slot="{ field, errors }"
                                v-model="alumno.nombre">
                                <InputText v-bind="field" type="text" class="input-base"
                                    :placeholder="$t('label.nombre')"
                                    :class="{ 'bg-white': true, 'input-error': errors.length > 0 }" />
                                <span class="text-sm text-red-500 p-error">
                                    <ErrorMessage :name="`alumnos[${index}].nombre`" />
                                </span>
                            </Field>
                        </div>
                        <div class="w-full px-2 md:w-4/12">
                            <label class="block mb-1">{{ $t('label.apellido') }}</label>
                            <Field :name="`alumnos[${index}].apellido`" v-slot="{ field, errors }"
                                v-model="alumno.apellido">
                                <InputText v-bind="field" type="text" class="input-base"
                                    :placeholder="$t('label.apellido')"
                                    :class="{ 'bg-white': true, 'input-error': errors.length > 0 }" />
                                <span class="text-sm text-red-500 p-error">
                                    <ErrorMessage :name="`alumnos[${index}].apellido`" />
                                </span>
                            </Field>
                        </div>
                    </div>
                </div>

                <div class="mt-4">
                    <button type="button" @click="addAlumno"
                        class="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700">
                        <i class="pi pi-plus mr-2"></i> {{ $t('label.agregar.alumno') }}
                    </button>
                </div>


                <div class="flex flex-wrap py-2 mt-3 jusi">
                    <button type="submit"
                        class="mt-8 px-4 py-2 bg-transparent border-blue-950 hover:bg-cyan-600 text-blue-950 font-semibold hover:text-white border rounded"
                        :disabled="isSubmitting">
                        <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
                        <i v-show="!isSubmitting" class="pi pi-check mr-2"></i> {{ $t('boton.registrarme') }}
                    </button>
                </div>
            </div>

            <BlockUI :blocked="isSubmitting" fullScreen />

        </Form>

    </section>
</template>

<script lang="ts">
import * as yup from 'yup';
import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import BlockUI from 'primevue/blockui';
import HeaderSection from '@/components/HeaderSection.vue'

import suiteService, { Acreditado, OrigenAcreditado, TipoAcreditado } from 'qreventos-suite/services';
import { SAVE, ORIGEN_ACREDITADO } from "qreventos-suite/constantes";
import suiteConfig from '@/services/suite.config';

interface Alumno {
    nombre: string;
    apellido: string;
    dni: string;
}

export default defineComponent({
    name: 'FormColegio',
    components: {
        HeaderSection,
        InputText,
        Field, ErrorMessage, Form, BlockUI
    },
    data() {
        return {
            isSubmitting: false,
            formData: {
                dni: '',
                nombre: '',
                apellido: '',
                empresa: '',
                mail: '',
                alumnos: [] as Alumno[]
            }
        };
    },
    computed: {
        schema() {
            return yup.object({
                dni: yup.string().required(this.$t('errors.dni.required')).min(6, this.$t('errors.dni.min')),
                nombre: yup.string().required(this.$t('errors.name.required')).min(3, this.$t('errors.name.min')),
                apellido: yup.string().required(this.$t('errors.lastname.required')).min(3, this.$t('errors.lastname.min')),
                empresa: yup.string().required(this.$t('errors.empresa.required')).min(3, this.$t('errors.empresa.min')),
                mail: yup.string().required(this.$t('errors.email.required')).email(this.$t('errors.email.invalid')),
                alumnos: yup.array().of(
                    yup.object().shape({
                        dni: yup.string().required(this.$t('errors.dni.required')),
                        nombre: yup.string().required(this.$t('errors.name.required')),
                        apellido: yup.string().required(this.$t('errors.lastname.required'))
                    })
                )
            });
        },
    },
    methods: {
        addAlumno() {
            this.formData.alumnos.push({ nombre: '', apellido: '', dni: '' });
        },
        removeAlumno(index: number) {
            this.formData.alumnos.splice(index, 1);
        },
        async hideSubmit() {
            this.isSubmitting = false;
            await this.$nextTick();
        },
        onInvalidSubmit(values: any) {
            const errores: number = Object.values(values?.errors || {}).flat().length;
            Swal.fire({ title: "Error", html: this.$t("error.revise") + " " + errores, icon: "error" });
        },
        async onSubmit() {
            this.isSubmitting = true;

            try {
                let acreditadoExistente: Acreditado[] = await suiteService.findAcreditadosByFilters(suiteConfig.evento, "dni=" + encodeURIComponent(this.formData.dni));
                if (acreditadoExistente.length > 0) {
                    await this.hideSubmit();
                    Swal.fire({ title: this.$t('global.atencion'), html: this.$t('mensaje.ya.acreditado'), icon: "warning" });
                    return;
                }

                // Coordinator
                const coordinador: Acreditado = {} as Acreditado;
                coordinador.tipoAcreditado = { "id": 2058 } as TipoAcreditado;
                coordinador.origenAcreditado = { "id": ORIGEN_ACREDITADO } as OrigenAcreditado;
                coordinador.dni = this.formData.dni;
                coordinador.nombre = this.formData.nombre;
                coordinador.apellido = this.formData.apellido;
                coordinador.empresa = this.formData.empresa; // Institution
                coordinador.mail = this.formData.mail; // Email
                coordinador.cantidad = 1;
                coordinador.notificar = true;
                coordinador.modificado = SAVE;

                const acreditadosParaGuardar: Acreditado[] = [coordinador];

                // Students
                this.formData.alumnos.forEach(alumno => {
                    const accAlumno: Acreditado = {} as Acreditado;
                    accAlumno.tipoAcreditado = { "id": 2058 } as TipoAcreditado;
                    accAlumno.origenAcreditado = { "id": ORIGEN_ACREDITADO } as OrigenAcreditado;
                    accAlumno.dato10 = alumno.dni;
                    accAlumno.nombre = alumno.nombre;
                    accAlumno.apellido = alumno.apellido;
                    accAlumno.empresa = this.formData.empresa; // Same institution
                    accAlumno.dato8 = this.formData.dni; // Coordinator's DNI
                    accAlumno.cantidad = 1;
                    accAlumno.notificar = false;
                    accAlumno.modificado = SAVE;
                    acreditadosParaGuardar.push(accAlumno);
                });

                const acreditadosResultado = await suiteService.saveOrUpdateAll(suiteConfig.evento, acreditadosParaGuardar);

                if (acreditadosResultado) {
                    await this.hideSubmit();
                    Swal.fire({ title: "Éxito", html: "Registro completado correctamente", icon: "success" }).then(() => {
                        this.$router.go(0);
                    });
                }
            } catch (error) {
                await this.hideSubmit();
                Swal.fire({ title: "Error", text: error + '', icon: "error" });
            } finally {
                await this.hideSubmit();
            }
        },
    }
});
</script>
